
import { RequestPaging } from "@/utils/util";
import { Component, Vue } from "vue-property-decorator";
import LsDialog from "@/components/ls-dialog.vue";
import LsPagination from "@/components/ls-pagination.vue";
import PopoverInput from "@/components/popover-input.vue";
import LsForm from "@/components/ls-form.vue";
import {
  apiModelModelTagCategoryLists,
  apiModelModelTagCategoryAdd,
  apiModelModelTagCategoryEdit,
  apiModelModelTagCategoryDelete,
} from "@/api/model.ts";
@Component({
  components: {
    LsDialog,
    LsPagination,
    PopoverInput,
    LsForm,
  },
})
export default class ModelType extends Vue {
  pager: RequestPaging = new RequestPaging();
  searchObj: any = {
    zh_cn_name: "",
  };

  dataForm = {
    id: "",
    zh_cn_name: "",
    en_name: "",
    sort: 1,
    status: 1,
  };

  formData = [
    {
      type: "input",
      label: "名称",
      key: "zh_cn_name",
      rules: [{ required: true, message: "请输入名称", trigger: "blur" }],
    },
    {
      type: "input",
      label: "英文名称",
      key: "en_name",
      rules: [{ required: true, message: "请输入英文名称", trigger: "blur" }],
    },
    {
      type: "input",
      label: "排序",
      key: "sort",
    },
    {
      type: "radio",
      label: "状态",
      key: "status",
      list: [
        { label: "正常", value: 1 },
        { label: "停用", value: 0 },
      ],
    },
  ];

  mode = "add";
  formVisible = false;

  handleAdd() {
    this.dataForm = {
      id: "",
      zh_cn_name: "",
      en_name: "",
      sort: 1,
      status: 1,
    };
    this.mode = "add";
    this.formVisible = true;
  }

  handleEdit(row: any) {
    this.dataForm = {
      id: row.id,
      zh_cn_name: row.zh_cn_name,
      en_name: row.en_name,
      sort: row.sort,
      status: row.status,
    };
    this.mode = "edit";
    this.formVisible = true;
  }

  handleSubmit(value: object) {
    if (this.mode == "add") {
      apiModelModelTagCategoryAdd(value).then((res: any) => {
        this.getList();
        this.formVisible = false;
      });
    } else {
      apiModelModelTagCategoryEdit(value).then((res: any) => {
        this.getList();
        this.formVisible = false;
      });
    }
  }

  handleDelete(id: number) {
    apiModelModelTagCategoryDelete({ id: id }).then((res: any) => {
      this.getList();
    });
  }

  getList(): void {
    this.pager.request({
      callback: apiModelModelTagCategoryLists,
      params: {
        ...this.searchObj,
      },
    });
  }

  created() {
    this.getList();
  }
}
